var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Root, Handle } from './styled';
function getRadii(size) {
    switch (size) {
        case 'sm':
            return 16;
        case 'md':
        default:
            return 22;
    }
}
/**
 * A control that allows the user to toggle between checked and not checked.
 * @see https://base-ui.com/react/components/switch
 */
export function Switch(props) {
    const { size, onCheckedChange, onBlur, onClick } = props, rest = __rest(props, ["size", "onCheckedChange", "onBlur", "onClick"]);
    const radii = getRadii(size);
    const handleBlur = (event) => {
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
    };
    const handleClick = (event) => {
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    };
    return (<Root $radii={radii} onCheckedChange={onCheckedChange} onBlur={handleBlur} onClick={handleClick} {...rest}>
      <Handle $radii={radii}/>
    </Root>);
}
